module.exports = __webpack_public_path__ + "static/media/attachment-document-icon.951d0829.svg";